import * as React from "react";
import { SVGProps } from "react";

const Kava = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 2000 2210"
    {...props}
  >
    <style>{".st2{fill:#ff564f}"}</style>
    <path
      fill="#ff564f"
      d="M198.5 1841.3 321.6 2210l845-1105L321.6 0 192.5 360.7l561.3 744.1-555.3 736.5z"
      opacity={0.2}
    />
    <path
      fill="#f08179"
      d="M1999.7 2209.8h-401l-845.2-1105L1598.7 0h401l-833.3 1104.8 833.3 1105z"
    />
    <path d="M0 0h321.4v2209.8H0V0z" className="st2" />
    <path
      id="_x30_"
      d="M2000 2209.8h-401l-845.2-1105L1599 0h401l-833.3 1104.8 833.3 1105z"
      className="st2"
    />
    <path
      id="_x30__1_"
      d="M2000 2209.8h-401l-845.2-1105L1599 0h401l-833.3 1104.8 833.3 1105z"
      className="st2"
    />
    <path
      id="_x30__2_"
      d="M2000 2209.8h-401l-845.2-1105L1599 0h401l-833.3 1104.8 833.3 1105z"
      className="st2"
    />
    <path
      id="_x30__3_"
      d="M2000 2209.8h-401l-845.2-1105L1599 0h401l-833.3 1104.8 833.3 1105z"
      className="st2"
    />
  </svg>
);

export default Kava;
